import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/fillapp-website/fillapp-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionButton","AccordionPanel"] */ "/home/runner/work/fillapp-website/fillapp-website/src/components/animate-ui/headless/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/fillapp-website/fillapp-website/src/components/shared/Navbar.tsx");
